module.exports = __webpack_public_path__ + "static/media/tick_green.52183ba7.svg";